'use strict';

/**
 * @param {string} url - Absolute storefront URL
 * @returns {string} normalized host
 */
function getHost(url) {
    var match = /^https?:\/\/([^/]+)/i.exec(url);
    return match ? match[1].toLowerCase() : '';
}

/**
 * @param {string} url - Configured regional URL
 * @param {string} host - Current request host
 * @param {string} siteID - Current site ID
 * @returns {boolean} whether the destination is the current storefront
 */
function isCurrentSite(url, host, siteID) {
    var site = /\/s\/([^/?#]+)/.exec(url)
        || /\/on\/demandware\.store\/Sites-([^/]+)-Site\//.exec(url);
    var sameHost = getHost(url) === host.toLowerCase();
    if (site) {
        var targetHost = getHost(url).replace(/\.(my|dx)\.commercecloud\.salesforce\.com$/, '');
        var currentHost = host.toLowerCase().replace(/\.(my|dx)\.commercecloud\.salesforce\.com$/, '');
        return site[1] === siteID && targetHost === currentHost;
    }
    return sameHost;
}

/**
 * Merge raw query parameters without decoding refinement values or losing repeated keys.
 * @param {string} url - Destination URL
 * @param {string} queryString - Current query string
 * @param {string} hash - Current fragment
 * @returns {string} destination with current parameters
 */
function withQueryString(url, queryString, hash) {
    var parts = url.split('#')[0].split('?');
    var incoming = (queryString || '').replace(/^\?/, '').split('&').filter(function (pair) {
        return pair && pair.split('=')[0] !== 'lang';
    });
    var keys = incoming.map(function (pair) { return pair.split('=')[0]; });
    var existing = (parts[1] || '').split('&').filter(function (pair) {
        return pair && keys.indexOf(pair.split('=')[0]) === -1;
    });
    var query = existing.concat(incoming).join('&');
    return parts[0] + (query ? '?' + query : '') + (hash || '');
}

/**
 * Keep the destination host trusted while carrying a storefront path between regions.
 * @param {string} targetURL - Configured destination origin and optional locale prefix
 * @param {string} path - Current storefront path
 * @param {string} queryString - Current query string
 * @param {string} hash - Current fragment
 * @returns {string} regional destination
 */
function buildURL(targetURL, path, queryString, hash) {
    var target = targetURL.split(/[?#]/)[0].replace(/\/+$/, '');
    target = target.replace(/\/on\/demandware\.store\/Sites-([^/]+)-Site\/[^/]+\/[^/]+$/, '/s/$1');
    var sandboxTarget = /\/s\/[^/]+(?:\/.*)?$/.test(target);
    if (sandboxTarget) {
        target = target.replace(/\/home$/, '');
    }
    var newPath = (path || '').replace(/^https?:\/\/[^/]+/i, '').split(/[?#]/)[0];
    newPath = newPath.replace(/^\/s\/[^/]+/, '')
        .replace(/^\/on\/demandware\.store\/Sites-[^/]+-Site\/[^/]+/, '');
    newPath = '/' + newPath.replace(/^\/+/, '');
    var sourceLocale = /^\/(en|en_GB)(?=\/|$)/.exec(newPath);
    newPath = newPath.replace(/^\/(en|en_GB)(?=\/|$)/, '');
    var targetPath = target.replace(/^https?:\/\/[^/]+/i, '');
    if (!targetPath && getHost(target).indexOf('eu') !== -1) {
        target += sourceLocale ? sourceLocale[0] : '/en';
    }
    return withQueryString(target + (newPath || '/'), queryString, hash);
}

module.exports = {
    getHost: getHost,
    isCurrentSite: isCurrentSite,
    withQueryString: withQueryString,
    buildURL: buildURL
};
